<template>
  <div class="v-application--wrap">
    <the-layout-navigation v-if="navigationShow" :show-drawer="showDrawer" @toggle-nav-drawer="toggleNavDrawer" />
    <the-layout-toolbar @toggle-nav-drawer="toggleNavDrawer" />
    <the-layout-content />
    <the-layout-to-top-fab />
    <the-layout-footer />
    <AttachmentsPreview v-if="showPreview" :attachment="selectedAttachment" />
  </div>
</template>

<script>
import AttachmentsPreview from '@/atoms/AttachmentsPreview.vue';
import TheLayoutNavigation from './TheLayoutNavigation.vue';
import TheLayoutToolbar from './TheLayoutToolbar.vue';
import TheLayoutContent from './TheLayoutContent.vue';
import TheLayoutToTopFab from './TheLayoutToTopFab.vue';
import TheLayoutFooter from './TheLayoutFooter.vue';

export default {
  name: 'TheLayout',
  components: {
    AttachmentsPreview,
    TheLayoutNavigation,
    TheLayoutToolbar,
    TheLayoutContent,
    TheLayoutToTopFab,
    TheLayoutFooter,
  },
  data() {
    return {
      showDrawer: false,
      intervalRef: null,
    };
  },
  computed: {
    navigationShow() {
      let showCondition = true;
      if (this.isMobileDevice) {
        showCondition = this.showDrawer;
      }

      return showCondition;
    },
  },
  created() {
    // hack for breakpoints not triggered when changing orientation on iphone
    // TODO:: find a better way
    this.intervalRef = setInterval(() => {
      this.$vuetify.breakpoint.update();
    }, 400);
  },
  destroyed() {
    clearInterval(this.intervalRef);
  },
  methods: {
    toggleNavDrawer(val) {
      if (val) {
        this.$store.dispatch('NavbarState', { state: val });
        this.showDrawer = val;
      } else {
        this.showDrawer = !this.showDrawer;
        this.$store.dispatch('NavbarState', { state: this.showDrawer });
      }
    },
  },
};
</script>

<style>
.v-application--wrap {
  min-height: 100dvh;
}
</style>
